(function () {
  function setThumbActiveByIndex(index) {
    const thumbs = document.querySelectorAll('.thumbnails .thumbnail');
    if (!thumbs.length) return;

    const current = document.querySelector('.thumbnails .thumbnail.thumbnail--active')
      || document.querySelector('.thumbnails .thumbnail[aria-current="true"]');

    const target = thumbs[index] || thumbs[0];
    if (!target) return;

    // Si déjà bon, on ne touche à rien (évite du flicker/repaint)
    if (current === target) return;

    // Batch DOM update dans la même frame
    requestAnimationFrame(() => {
      if (current) {
        current.classList.remove('thumbnail--active');
        current.removeAttribute('aria-current');
      }
      target.classList.add('thumbnail--active');
      target.setAttribute('aria-current', 'true');
    });
  }

  function bindSlickEvents() {
    if (!window.jQuery) return false;

    const $ = window.jQuery;
    const $slideshow = $('.product-slideshow');
    if (!$slideshow.length) return false;

    $slideshow.off('.thumbFix');

    // IMPORTANT : dès le début du swipe, on allume le prochain carré
    $slideshow.on('beforeChange.thumbFix', function (event, slick, currentSlide, nextSlide) {
      const idx = (typeof nextSlide === 'number') ? nextSlide : 0;
      setThumbActiveByIndex(idx);
    });

    // Sécurité après transition
    $slideshow.on('afterChange.thumbFix', function (event, slick, currentSlide) {
      const idx = (typeof currentSlide === 'number') ? currentSlide : 0;
      setThumbActiveByIndex(idx);
    });

    // Si déjà initialisé
    if ($slideshow.hasClass('slick-initialized')) {
      const slick = $slideshow.slick('getSlick');
      const idx = (slick && typeof slick.currentSlide === 'number') ? slick.currentSlide : 0;
      setThumbActiveByIndex(idx);
    }

    return true;
  }

  function initWhenReady() {
    if (bindSlickEvents()) return;

    let tries = 0;
    const timer = setInterval(() => {
      tries += 1;
      if (bindSlickEvents() || tries >= 50) clearInterval(timer);
    }, 100);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initWhenReady);
  } else {
    initWhenReady();
  }
})();
